<template>
  <v-container fluid grid-list-xl>
  <v-layout>
    <v-flex>
      <h1>Unsere Vorhaben für 2019</h1>
    </v-flex>
  </v-layout>

  <v-layout>
    <v-flex>
      <h2>20 Maßnahmen geplant</h2>
    </v-flex>
  </v-layout>

  <v-layout row wrap>
    <v-flex xs12 sm8>
     <h4>Allgemein</h4>
      <v-layout row wrap>
        <v-flex xs12>
          <v-card>
            <v-card-title>
              <h3>Downloadbereich</h3><br>
              <p>für Material, Templates und Anregungen zur individuellen Potenzialentfaltung oder in Gruppen</p>
            </v-card-title>
            <v-divider></v-divider>
            <v-card-actions>
              <v-chip>Priorität 1</v-chip>
              <v-chip>Quartal 1</v-chip>
            </v-card-actions>
          </v-card>
        </v-flex>
        <v-flex xs12>
          <v-card class="pa-3">
            Mobile Applikation für iOS
          </v-card>
        </v-flex>
        <v-flex xs12>
          <v-card class="pa-3">
            Login-Bereich der Ideenpioniere und Förderung der Community
          </v-card>
        </v-flex>
        <v-flex xs12>
          <v-card class="pa-3">
            neue wöchentliche Übungen
          </v-card>
        </v-flex>
      </v-layout>
      <h4>Soziale Medien</h4>
      <v-layout row wrap>
        <v-flex xs12>
          <v-card class="pa-3">
            Instagram-Format
          </v-card>
        </v-flex>
        <v-flex xs12>
          <v-card class="pa-3">
            Instagram-Stories
          </v-card>
        </v-flex>
      </v-layout>
    </v-flex>
    <v-flex xs12 sm4>

      <!-- Ideenparty -->
      <h4>Ideenparties</h4>
      <v-layout row wrap>
        <v-flex xs12>
          <v-card color="primary" style="color: white" class="pa-3">
             <v-list two-line>

          <v-list-tile avatar>
            <v-list-tile-content>
              <v-list-tile-title>12x Köln</v-list-tile-title>
              <v-list-tile-sub-title>nächster Termin: 16.01.2019</v-list-tile-sub-title>
            </v-list-tile-content>
          </v-list-tile>

          <v-list-tile avatar>
            <v-list-tile-content>
              <v-list-tile-title>4x Essen</v-list-tile-title>
              <v-list-tile-sub-title>Termin-Ankündigung folgt</v-list-tile-sub-title>
            </v-list-tile-content>
          </v-list-tile>

          <v-list-tile avatar>
            <v-list-tile-content>
              <v-list-tile-title>2x Berlin</v-list-tile-title>
              <v-list-tile-sub-title>Termin-Ankündigung folgt</v-list-tile-sub-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-list>
          </v-card>
        </v-flex>

        <v-flex xs12>
          <v-card class="pa-3">
            Aufbauseminar aus Ideenparty-Format
          </v-card>
        </v-flex>
      </v-layout>

      <!-- Kartensets -->
      <h4>Kartensets</h4>
      <v-layout row wrap>
        <v-flex xs12>
          <v-card class="pa-3">
            Vertrieb von "Für dich"
          </v-card>
        </v-flex>
        <v-flex xs12>
          <v-card class="pa-3">
            Entwicklung im Bereich des Team Coachings
          </v-card>
        </v-flex>
        <v-flex xs12>
          <v-card class="pa-3">
            Entwicklung im Bereich der Supervision
          </v-card>
        </v-flex>
        <v-flex xs12>
        </v-flex>
      </v-layout>

      <!-- Podcast -->
      <h4>Podcast</h4>
      <v-layout row wrap>
        <v-flex xs12>
          <v-card class="pa-3">
            Gäste 1 / 12
          </v-card>
        </v-flex>
        <v-flex xs12>
          <v-card class="pa-3">
            neues Format
          </v-card>
        </v-flex>
      </v-layout>
    </v-flex>
  </v-layout>
  </v-container>
</template>

<script>
export default {
  data () {
    return {
      notifications: false,
      sound: true,
      video: false,
      invites: false
    }
  }
}
</script>
